import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/existing`;

export const ROUTE: RouteDefinition = `${baseRoute}/existing`;

export const URL = (): RouteDefinition => `${baseRoute}/existing`;
